import React, { useEffect, useState } from 'react'

import { ImageWrapper, Container, CategoryWrapper } from './styled-components'
import DropDown from './DropDown'
import CategoryBar from './CategoryBar'

/**
 *
 * @param {string} image - the header image
 * @param {array} categories - a list of available categories
 * @param {string} category - current active category
 *
 * This section renders a header image
 * below the image on mobile devices a dropdown list is rendered
 * on desktop it is a horizontal list
 */
const PageHeader = ({ image, categories, category }) => {
  const [isMobile, setIsMobile] = useState(true)

  useEffect(() => {
    window && setIsMobile(window.innerWidth < 736)

    window &&
      window.addEventListener('resize', e => {
        setIsMobile(e.target.innerWidth < 736)
      })
  }, [])

  const navItems = categories.map(item => item.node).sort((a, b) => a.priority - b.priority);

  return (
    <>
      <ImageWrapper url={image} />
      {categories.length > 0 && (
        <CategoryWrapper>
          <Container>
            {isMobile ? (
              <DropDown items={navItems} active={category} />
            ) : (
              <CategoryBar items={navItems} active={category} />
            )}
          </Container>
        </CategoryWrapper>
      )}
    </>
  )
}

PageHeader.defaultProps = {
  image: 'https://picsum.photos/1920/1200',
  categories: [
    {
      title: 'News',
      url: 'http://google.com',
    },
    {
      title: 'Nachhaltigkeit',
      url: 'http://google.com',
    },
    {
      title: 'Produktion',
      url: 'http://google.com',
    },
    {
      title: 'Style',
      url: 'http://google.com',
    },
    {
      title: 'Geschichte',
      url: 'http://google.com',
    },
    {
      title: 'Presse',
      url: 'http://google.com',
    },
  ],
}

export default PageHeader
